import { getDefaultShopConfig } from './default';
import { getConditionsFilterConfig } from '../filters/condition';
import * as custom from '../filters/marketplace-custom-config';
import { getSizeFilterConfig } from '../filters/size';
import { getColorFilterConfig } from '../filters/color';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { BuilderSections } from '../../util/builder';

const billyreidSizes = [
  'ONE',

  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  'XXXL',

  'XS/S',
  'S/M',
  'M/L',
  'L/XL',

  'LT',
  'XLT',
  'XXLT',

  '00',
  '0',
  '2',
  '4',
  '6',
  '8',
  '10',
  '12',

  '7',
  '8.0',
  '8.5',
  '9',
  '9.5',
  '10.0',
  '10.5',
  '11',
  '11.5',
  '12.0',

  '13',
  '15',
  '15.5',
  '16',
  '16.5',
  '17',
  '17.5',

  '28',
  '29',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '38',
  '40',

  '29.0',
  '30.0',
  '31.0',
  '32.0',
  '33.0',
  '34.0',
  '35.0',
  '36.0',
  '38.0',
  '40.0',

  '40S',
  '42S',
  '44S',
  '46S',

  '36R',
  '38R',
  '40R',
  '42R',
  '44R',
  '46R',
  '48R',

  '36L',
  '38L',
  '40L',
  '42L',
  '44L',
  '46L',
  '48L',

  '29X30',
  '29X32',
  '30X30',
  '30X32',
  '30X34',
  '31X30',
  '31X32',
  '31X34',
  '32X30',
  '32X32',
  '32X34',
  '32X36',
  '33X30',
  '33X32',
  '33X34',
  '34X30',
  '34X32',
  '34X34',
  '34X36',
  '35X30',
  '35X32',
  '35X34',
  '36X30',
  '36X32',
  '36X34',
  '36X36',
  '38X30',
  '38X32',
  '40X30',
  '40X32',
];

export const billyreidShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getSizeFilterConfig({ sizes: billyreidSizes }),
    getColorFilterConfig(),
    getBrandDirectFilterConfig(),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: '6d69973818b54d19933c4d5e6b031635',
      [BuilderSections.SubscribeFormFooterContent]: '4b82cb2aca3a42c69e68da936b05a2d3',
      [BuilderSections.TopbarContent]: '952ecc4522074dfa800742af765b810c',
    },
  },
};
